import {
    GET_ORDER_LISTING,
    GET_ORDER_LISTING_SUCCESS,
    GET_ORDER_LISTING_FAIL,
    GET_ORDER_DETAILS,
    GET_ORDER_DETAILS_SUCCESS,
    GET_ORDER_DETAILS_FAIL,
    ADD_ORDER,
    ADD_ORDER_SUCCESS,
    ADD_ORDER_FAIL,
    UPDATE_ORDER,
    UPDATE_ORDER_SUCCESS,
    UPDATE_ORDER_FAIL,
    DELETE_ORDER,
    DELETE_ORDER_SUCCESS,
    DELETE_ORDER_FAIL,
    EXPORT_ORDER,
    EXPORT_ORDER_SUCCESS,
    EXPORT_ORDER_FAIL,
    RESET_ORDER_STATE,
    RESET_ORDER_ATTACHMENT_STATE,
    INSERT_LOG_ORDER,
    INSERT_LOG_ORDER_SUCCESS,
    INSERT_LOG_ORDER_FAIL,
    UPDATE_CUSTOMER_DETAILS,
    UPDATE_CUSTOMER_DETAILS_SUCCESS,
    UPDATE_CUSTOMER_DETAILS_FAIL,
    UPDATE_SHIPPING_DETAILS,
    UPDATE_SHIPPING_DETAILS_SUCCESS,
    UPDATE_SHIPPING_DETAILS_FAIL,
    MARK_AS_PAID,
    MARK_AS_PAID_SUCCESS,
    MARK_AS_PAID_FAIL,
    MARK_AS_CLOSED,
    MARK_AS_CLOSED_SUCCESS,
    MARK_AS_CLOSED_FAIL,
    UPDATE_BILLING_DETAILS,
    UPDATE_BILLING_DETAILS_SUCCESS,
    UPDATE_BILLING_DETAILS_FAIL,
    UPDATE_STATUS,
    UPDATE_STATUS_SUCCESS,
    UPDATE_STATUS_FAIL,
    UPDATE_COURIER,
    UPDATE_COURIER_SUCCESS,
    UPDATE_COURIER_FAIL,
    REVERT_ORDER_STATUS,
    REVERT_ORDER_STATUS_SUCCESS,
    REVERT_ORDER_STATUS_FAIL,
    DOWNLOAD_INVOICE,
    DOWNLOAD_INVOICE_SUCCESS,
    DOWNLOAD_INVOICE_FAIL,
} from "./actionTypes";

export const getOrderListing = order => ({
    type: GET_ORDER_LISTING,
    payload: order,
});

export const getOrderListingSuccess = order => ({
    type: GET_ORDER_LISTING_SUCCESS,
    payload: order,
});

export const getOrderListingFail = error => ({
    type: GET_ORDER_LISTING_FAIL,
    payload: error,
});

export const getOrderDetails = orderId => ({
    type: GET_ORDER_DETAILS,
    payload: orderId,
});

export const getOrderDetailsSuccess = order => ({
    type: GET_ORDER_DETAILS_SUCCESS,
    payload: order,
});

export const getOrderDetailsFail = error => ({
    type: GET_ORDER_DETAILS_FAIL,
    payload: error,
});

export const createOrder = order => ({
    type: ADD_ORDER,
    payload: order,
});

export const createOrderSuccess = order => ({
    type: ADD_ORDER_SUCCESS,
    payload: order,
});

export const createOrderFail = error => ({
    type: ADD_ORDER_FAIL,
    payload: error,
});

export const updateOrder = order => ({
    type: UPDATE_ORDER,
    payload: order,
});

export const updateOrderSuccess = order => ({
    type: UPDATE_ORDER_SUCCESS,
    payload: order,
});

export const updateOrderFail = error => ({
    type: UPDATE_ORDER_FAIL,
    payload: error,
});

export const deleteOrder = orderId => ({
    type: DELETE_ORDER,
    payload: orderId,
});

export const deleteOrderSuccess = orderId => ({
    type: DELETE_ORDER_SUCCESS,
    payload: orderId,
});

export const deleteOrderFail = error => ({
    type: DELETE_ORDER_FAIL,
    payload: error,
});

export const insertLogOrder = payload => ({
    type: INSERT_LOG_ORDER,
    payload: payload,
});

export const insertLogOrderSuccess = payload => ({
    type: INSERT_LOG_ORDER_SUCCESS,
    payload: payload,
});

export const insertLogOrderFail = error => ({
    type: INSERT_LOG_ORDER_FAIL,
    payload: error,
});

export const updateCustomerDetailsOrder = payload => ({
    type: UPDATE_CUSTOMER_DETAILS,
    payload: payload,
});

export const updateCustomerDetailsOrderSuccess = payload => ({
    type: UPDATE_CUSTOMER_DETAILS_SUCCESS,
    payload: payload,
});

export const updateCustomerDetailsOrderFail = error => ({
    type: UPDATE_CUSTOMER_DETAILS_FAIL,
    payload: error,
});

export const updateShippingDetailsOrder = payload => ({
    type: UPDATE_SHIPPING_DETAILS,
    payload: payload,
});

export const updateShippingDetailsOrderSuccess = payload => ({
    type: UPDATE_SHIPPING_DETAILS_SUCCESS,
    payload: payload,
});

export const updateShippingDetailsOrderFail = error => ({
    type: UPDATE_SHIPPING_DETAILS_FAIL,
    payload: error,
});

export const updateBillingDetailsOrder = payload => ({
    type: UPDATE_BILLING_DETAILS,
    payload: payload,
});

export const updateBillingDetailsOrderSuccess = payload => ({
    type: UPDATE_BILLING_DETAILS_SUCCESS,
    payload: payload,
});

export const updateBillingDetailsOrderFail = error => ({
    type: UPDATE_BILLING_DETAILS_FAIL,
    payload: error,
});

export const markAsPaidOrder = payload => ({
    type: MARK_AS_PAID,
    payload: payload,
});

export const markAsPaidOrderSuccess = payload => ({
    type: MARK_AS_PAID_SUCCESS,
    payload: payload,
});

export const markAsPaidOrderFail = error => ({
    type: MARK_AS_PAID_FAIL,
    payload: error,
});

export const markAsClosed = payload => ({
    type: MARK_AS_CLOSED,
    payload: payload,
});

export const markAsClosedSuccess = payload => ({
    type: MARK_AS_CLOSED_SUCCESS,
    payload: payload,
});

export const markAsClosedFail = error => ({
    type: MARK_AS_CLOSED_FAIL,
    payload: error,
});

export const updateOrderStatus = data => ({
    type: UPDATE_STATUS,
    payload: data
});

export const updateOrderStatusSuccess = data => ({
    type: UPDATE_STATUS_SUCCESS,
    payload: data,
});

export const updateOrderStatusFail = error => ({
    type: UPDATE_STATUS_FAIL,
    payload: error,
});

export const updateOrderCourier = data => ({
    type: UPDATE_COURIER,
    payload: data
});

export const updateOrderCourierSuccess = data => ({
    type: UPDATE_COURIER_SUCCESS,
    payload: data,
});

export const updateOrderCourierFail = error => ({
    type: UPDATE_COURIER_FAIL,
    payload: error,
});

export const revertOrderStatus = data => ({
    type: REVERT_ORDER_STATUS,
    payload: data
});

export const revertOrderStatusSuccess = data => ({
    type: REVERT_ORDER_STATUS_SUCCESS,
    payload: data,
});

export const revertOrderStatusFail = error => ({
    type: REVERT_ORDER_STATUS_FAIL,
    payload: error,
});

export const downloadInvoice = data => ({
    type: DOWNLOAD_INVOICE,
    payload: data
});

export const downloadInvoiceSuccess = data => ({
    type: DOWNLOAD_INVOICE_SUCCESS,
    payload: data,
});

export const downloadInvoiceFail = error => ({
    type: DOWNLOAD_INVOICE_FAIL,
    payload: error,
});

export const exportOrder = data => ({
    type: EXPORT_ORDER,
    payload: data
});

export const exportOrderSuccess = data => ({
    type: EXPORT_ORDER_SUCCESS,
    payload: data,
});

export const exportOrderFail = error => ({
    type: EXPORT_ORDER_FAIL,
    payload: error,
});

//reset
export const resetOrderState = () => {
    return {
        type: RESET_ORDER_STATE,
    }
}

//reset attachment
export const resetOrderAttachmentState = () => {
    return {
        type: RESET_ORDER_ATTACHMENT_STATE,
    }
}

